import { cn } from '@/lib/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    variant?: 'default' | 'pill' | 'card';
    shape?: 'default' | 'pill' | 'card' | 'panel'; tone?: 'default' | 'dark';
}

function Skeleton({ className, variant = 'default', shape, tone = 'default', ...props }: SkeletonProps) {
    const resolvedShape = shape ?? variant;
    return (
        <div
            className={cn(
                'animate-pulse bg-muted',
                resolvedShape === 'pill' ? 'rounded-full' : resolvedShape === 'card' ? 'rounded-2xl' : resolvedShape === 'panel' ? 'rounded-xl' : 'rounded-md', tone === 'dark' && 'bg-zinc-900',
                className
            )}
            {...props}
        />
    );
}

export { Skeleton };
export type { SkeletonProps };
